import {
  ETIQUETA_IDIOMA,
  ETIQUETA_IDIOMA_BREVE,
  IDIOMAS,
  cambiarIdioma,
  idiomaActual,
  useT,
} from '../i18n/index.js';

/**
 * El selector de idioma.
 *
 * Two languages, so two buttons rather than a dropdown: one tap, and both options are readable
 * without opening anything.
 *
 * It is on every screen somebody can arrive at cold — the install screen, the PIN pad, the
 * insecure-context warning — because somebody who cannot read the first screen cannot navigate
 * to the settings to fix it. And it is on the home screen, because a household where one person
 * reads the books in English and the other sells in Spanish swaps between them constantly, and
 * making that two taps through a settings page is two taps too many.
 *
 * `breve` shows ES/EN instead of the words. That is a weaker label, so it is only for the home
 * header, where spelling it out would push the shop's own name off a phone screen — and by then
 * the person has already passed a screen that said it in full.
 */
export function Idioma({ tamano = 'normal' }: { tamano?: 'normal' | 'compacto' | 'breve' }) {
  const t = useT();
  const actual = idiomaActual();
  const etiquetas = tamano === 'breve' ? ETIQUETA_IDIOMA_BREVE : ETIQUETA_IDIOMA;

  return (
    <div className={tamano === 'normal' ? 'flex flex-col gap-2' : 'flex gap-1'}>
      {tamano === 'normal' && <span className="etiqueta">{t('ajustes.idioma')}</span>}
      <div className="flex gap-1 rounded-xl bg-slate-800 p-1">
        {IDIOMAS.map((i) => (
          <button
            key={i}
            type="button"
            onClick={() => cambiarIdioma(i)}
            data-sin-icono="pestana"
            /* min-h-9 inside a p-1 wrapper clears 44px overall, same floor as every other action. */
            className={`flex min-h-9 flex-1 items-center justify-center rounded-lg text-sm transition ${
              tamano === 'breve' ? 'min-w-11 px-2' : 'px-3'
            } ${i === actual ? 'bg-marca-600 font-medium text-white' : 'text-slate-400 hover:bg-white/5 hover:text-slate-200'}`}
          >
            {etiquetas[i]}
          </button>
        ))}
      </div>
    </div>
  );
}
